/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadmitToFacility200ResponseData
 */
export interface ReadmitToFacility200ResponseData {
    /**
     * 
     * @type {boolean}
     * @memberof ReadmitToFacility200ResponseData
     */
    success?: boolean;
}

/**
 * Check if a given object implements the ReadmitToFacility200ResponseData interface.
 */
export function instanceOfReadmitToFacility200ResponseData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReadmitToFacility200ResponseDataFromJSON(json: any): ReadmitToFacility200ResponseData {
    return ReadmitToFacility200ResponseDataFromJSONTyped(json, false);
}

export function ReadmitToFacility200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadmitToFacility200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function ReadmitToFacility200ResponseDataToJSON(value?: ReadmitToFacility200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

